import React from "react";

import type { Theme } from "@mui/material";

import { numbers } from "@readai/pulse/theme";
import { px } from "@readai/pulse/utils";

declare module "@mui/material/styles" {
  interface Theme {
    sizes: {
      default: {
        xlarge: React.CSSProperties["height"];
        large: React.CSSProperties["height"];
        base: React.CSSProperties["height"];
        small: React.CSSProperties["height"];
        xsmall: React.CSSProperties["height"];
        xxsmall: React.CSSProperties["height"];
      };
      icon: {
        xlarge: React.CSSProperties["height"];
        large: React.CSSProperties["height"];
        base: React.CSSProperties["height"];
        small: React.CSSProperties["height"];
        xsmall: React.CSSProperties["height"];
      };
    };
  }

  interface ThemeOptions {
    sizes: {
      default: {
        xlarge?: React.CSSProperties["height"];
        large?: React.CSSProperties["height"];
        base?: React.CSSProperties["height"];
        small?: React.CSSProperties["height"];
        xsmall?: React.CSSProperties["height"];
        xxsmall?: React.CSSProperties["height"];
      };
      icon: {
        xlarge?: React.CSSProperties["height"];
        large?: React.CSSProperties["height"];
        base?: React.CSSProperties["height"];
        small?: React.CSSProperties["height"];
        xsmall?: React.CSSProperties["height"];
      };
    };
  }
}

const defaultSizes: Theme["sizes"]["default"] = {
  xlarge: px(numbers.numbers.sizeComponent.xlarge),
  large: px(numbers.numbers.sizeComponent.large),
  base: px(numbers.numbers.sizeComponent.base),
  small: px(numbers.numbers.sizeComponent.small),
  xsmall: px(numbers.numbers.sizeComponent.xsmall),
  xxsmall: px(numbers.numbers.sizeComponent.xxsmall),
};

const iconSizes: Theme["sizes"]["icon"] = {
  xlarge: px(numbers.numbers.sizeIcon.xlarge),
  large: px(numbers.numbers.sizeIcon.large),
  base: px(numbers.numbers.sizeIcon.base),
  small: px(numbers.numbers.sizeIcon.small),
  xsmall: px(numbers.numbers.sizeIcon.xsmall),
};

const sizes: Theme["sizes"] = {
  default: defaultSizes,
  icon: iconSizes,
};

export default sizes;
